/* globals window */
import './mapboxicons.css';
import { apiPut } from '../../brainApi';

/* Idea from Stack Overflow https://stackoverflow.com/a/51683226  */
class SaveLatLngBoundsButton {
  onClick = (event) => {
    const { _ne, _sw } = this._map.getBounds();

    const payload = {
      lat_lng_bounds: [_ne.lat, _ne.lng, _sw.lat, _sw.lng],
    };

    console.log('Save Lat Lng Bounds', payload);

    const shouldSave = window.confirm(
      'Do you want to save the current map bounds for all users?',
    );
    if (shouldSave) {
      apiPut('/z3p-configuration', payload).then((json) => {
        if (json.Status === 'Failure') {
          alert(`Error:\n\n${json.Message}`);
        } else {
          alert('Saved!');
        }
      });
    }
  };

  onAdd(map) {
    this._map = map;

    this._btn = document.createElement('button');
    this._btn.className = 'mapboxgl-ctrl-icon mapbox-gl-draw_polygon';
    this._btn.type = 'button';
    this._btn.title = 'Save Map Bounds';
    this._btn.onclick = this.onClick;

    this._container = document.createElement('div');
    this._container.className = 'mapboxgl-ctrl-group mapboxgl-ctrl';
    this._container.appendChild(this._btn);

    return this._container;
  }

  onRemove() {
    this._container.parentNode.removeChild(this._container);
    this._map = undefined;
  }
}

export default SaveLatLngBoundsButton;
